var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{staticClass:"timezone-picker",attrs:{"options":_vm.timezonesItems,"disabled":_vm.disabled,"placeholder":_vm.placeholder || _vm.$t('test.timezone.placeholder'),"title":_vm.title || this.$t('timezone'),"size":"xsmall"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }